var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColsaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 236.957,
    height: 49.838,
    viewBox: "0 0 236.957 49.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_83",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2707",
    d: "M573.508,1591.791c6.462-9.481,18.07-7.539,22.533.112l12.165-7.008c-9.413-15.718-32.36-10.423-34.7,6.9",
    transform: "translate(-558.745 -1575.54)",
    fill: "#f27a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2708",
    d: "M626.962,1636.846c5.005,10.319-2.487,19.369-11.364,19.4l0,14.006a18.6,18.6,0,0,0,11.359-33.409",
    transform: "translate(-589.555 -1620.416)",
    fill: "#f27a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2709",
    d: "M544.324,1636.823c-11.468-.843-15.585-11.833-11.173-19.517l-12.166-7c-8.947,15.988,7.125,33.155,23.339,26.514",
    transform: "translate(-518.42 -1600.991)",
    fill: "#f27a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2710",
    d: "M769.795,1631.835H756.38c-7.261,0-11.322-1.227-14.4-4.355-3.447-3.439-5.413-9.143-5.413-15.891,0-8.4,3.134-15.336,8.12-18.284,2.708-1.594,6.648-2.393,11.568-2.393h13.538v6.134H757c-4.861,0-7.69.921-9.473,3.255-1.729,2.145-2.771,6.318-2.771,11.041,0,5.46,1.413,9.756,3.752,11.9,1.97,1.777,4.369,2.453,8.861,2.453h12.431Z",
    transform: "translate(-678.107 -1586.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2711",
    d: "M890.024,1589.307c13.413,0,19.875,6.871,19.875,21.229,0,13.5-6.831,20.552-19.875,20.552-7.448,0-13.353-2.391-16.429-6.685-2.4-3.253-3.817-8.467-3.817-14.052,0-7.055,1.973-12.762,5.414-16.075,3.575-3.373,8.493-4.97,14.893-4.97Zm.061,5.952c-8.369,0-12.121,4.6-12.121,14.784,0,10.494,3.627,15.1,11.872,15.1,8.185,0,11.876-4.542,11.876-14.789,0-10.49-3.567-15.092-11.689-15.092Z",
    transform: "translate(-775.617 -1585.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2712",
    d: "M1036.164,1590.913v23.436c0,5.033.617,7.67,1.97,9.019,1.724,1.6,4.556,2.331,8.982,2.331h8.682v6.136h-9.728c-7.258,0-10.645-.983-13.595-3.867-2.708-2.635-3.754-6.317-3.754-13.192v-23.863Z",
    transform: "translate(-891.964 -1586.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2713",
    d: "M1139.408,1625.708h18.766c3.2,0,4.985-.306,6.1-1.044a5.026,5.026,0,0,0,2.4-4.6c0-2.517-1.175-4.539-3.2-5.275-1.108-.431-2.033-.552-4.8-.552h-5.29c-4.986,0-8.246-.737-10.338-2.332a10.8,10.8,0,0,1-4.061-8.774c0-4.908,2.524-9.08,6.463-10.86,2.151-.983,4.736-1.346,9.411-1.346h17.292v6.131h-16.923c-3.135,0-4.858.246-6.09.8a4.922,4.922,0,0,0-2.583,4.662c0,3.744,2.277,5.217,8.245,5.217h3.751c6.527,0,9.787.737,12.062,2.822,2.273,2.027,3.632,5.523,3.632,9.386,0,4.665-2.153,8.528-5.66,10.371-2.216,1.163-4.615,1.532-10.525,1.532H1139.47Z",
    transform: "translate(-972.673 -1586.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2714",
    d: "M1279.777,1610.37v-3.8c0-7.181,1.046-10.555,4.057-13.192,3.2-2.883,6.648-4.3,12.864-4.3,6.583,0,9.968,1.716,12.922,5.276,2.274,2.762,3.018,5.706,3.018,11.659v4.968l.059,19.51h-7.568v-14.05h-17.847v14.05h-7.505v-14.05m25.352-6.073v-4.294c0-4.416-.553-6.566-2.154-8.224-1.724-1.841-3.262-2.823-6.773-2.823-4.429,0-6.519,1.477-7.936,4.052-.739,1.349-.984,3.249-.984,7.3v3.989Z",
    transform: "translate(-1075.74 -1585.451)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColsaIcon);
export default __webpack_public_path__ + "static/media/colsaIcon.7816df4e78ace65d96dc51df10371b2b.svg";
export { ForwardRef as ReactComponent };